export default "__VITE_ASSET__f35fdf51__"